import { RefObject } from 'react';

const checkIsTruncated = (ref: RefObject<HTMLElement>) => {
  if (ref.current) {
    return (
      (ref.current as HTMLElement).scrollWidth >
      (ref.current as HTMLElement).clientWidth
    );
  }

  return false;
};

export default checkIsTruncated;
